<div class="userContainer d-flex align-items-start">

  <div class="userControlsContainer d-flex align-items-center">

    <div class="label-with-actions d-flex align-items-center">
      <div class="d-flex align-items-center support-observer">
        <span
          [style.color]="(localUser | isSupportOrObserver) ? localUser.personalColor:
                          (localUser | isTeacher) ? '#0c97bf' : '#596682'"
          class="userLabel text-truncate">{{localUser | fullName}}</span>
        <span class="support-observer-icon fa-solid"
          title="{{localUser.accessType === AccessType.SUPPORT ? 'Support' : 'Observer'}}"
          [ngClass]="{'fa-headset' : localUser.accessType === AccessType.SUPPORT, 'fa-binoculars' : localUser.accessType === AccessType.OBSERVER}"></span>
      </div>
    </div>

    <button type="button" class="unanswered-message mr-2" style="color: #909090"
            title="{{localUser.hasUnansweredMessage ? 'Unread message': 'No new messages'}}"
            [ngClass]="{'active': localUser.hasUnansweredMessage}"
            (click)="manuallyHideUnansweredMessageIcon()">
      <i class="fas fa-comment-dots"></i>
    </button>

    <div class="answerButtonsContainer d-flex align-items-center">
      <button *ngIf="localUser.accessType !== AccessType.OBSERVER"
              class="btn user-btn far fa-comment-times doNotCloseChat color-red" style="font-size: 15px"
              title="Clear chat"
              (click)="clearIndividualChat()"></button>
      <input #inputValue type="text" class="chatInput form-control"
             (copy)="utilService.safeCopy($event)"
             (cut)="utilService.safeCut($event)"
             (paste)="utilService.safePaste($event)"
             (keyup.enter)="selfMessage(inputValue.value)">
    </div>
  </div>

  <div class="briefLog-div ng-scope" *ngIf="messages.own.length > 0 ">
     <div class="user-item-messages" [ngClass]="{'show': isMessageBoxCollapsed}">
       <i *ngIf="isMessageBoxCollapsed " (click)="toggleShowMessages()" title="Expand chat"
         class="show-more-messages far fa-ellipsis-h ng-scope"
       ></i>
       <span class="briefLog" *ngIf="!isMessageBoxCollapsed">
                 <i class="asd" *ngFor="let message of messages.own, let i = index"
                    (copy)="utilService.safeCopy($event)"
                    (cut)="utilService.safeCut($event)"
                    [style]="(message.senderId | userById | isSupportOrObserver) ? 'color: ' + (message.senderId | userById).personalColor +' !important' :
                             (message.senderId | userById | isTeacher) ? 'color: #0c97bf !important' : 'color: #596682 !important'"
                    [ngClass]="{'student-message': message.messageType === MessageTypes.TO_STAFF && localUser.accessType === AccessType.STUDENT,
                               'teacher-message':  message.messageType === MessageTypes.TO_STUDENT || (localUser | isStaff)}">
                    > {{message.text}}
                 </i>
             </span>
       <span class="briefLog" *ngIf="isMessageBoxCollapsed">
                 <i class="asd" *ngFor="let message of messages.ownLimited, let i = index"
                    (copy)="utilService.safeCopy($event)"
                    (cut)="utilService.safeCut($event)"
                    [style]="(message.senderId | userById | isSupportOrObserver) ? 'color: ' + (message.senderId | userById).personalColor +' !important' :
                             (message.senderId | userById | isTeacher) ? 'color: #0c97bf !important' : 'color: #596682 !important'"
                    [ngClass]="{'student-message': message.messageType === MessageTypes.TO_STAFF && localUser.accessType === AccessType.STUDENT,
                                'teacher-message':  message.messageType === MessageTypes.TO_STUDENT || (localUser | isStaff)}">
                   > {{message.text}}
                 </i>
             </span>
       <i class="far fa-angle-double-up hide-more-messages ng-scope" *ngIf="!isMessageBoxCollapsed"
         (click)="toggleShowMessages()" title="Collapse chat"></i>
     </div>
   </div>
</div>
